"use client";

import { useEffect, useState, type ReactNode } from "react";

const DESKTOP_QUERY = "(min-width: 768px)";

/**
 * A footer link group. Under 768px it is a native disclosure, closed at first
 * paint with its links in the server HTML; from 768px it is a plain open
 * column and the heading stops being a control.
 */
export function FooterGroup({ title, children }: { title: ReactNode; children: ReactNode }) {
  const [desktop, setDesktop] = useState(false);

  useEffect(() => {
    const query = window.matchMedia(DESKTOP_QUERY);
    const sync = () => setDesktop(query.matches);
    sync();
    query.addEventListener("change", sync);
    return () => query.removeEventListener("change", sync);
  }, []);

  return (
    <details
      open={desktop || undefined}
      className="group md:[&::details-content]:[content-visibility:visible]"
    >
      <summary
        tabIndex={desktop ? -1 : undefined}
        onClick={desktop ? (event) => event.preventDefault() : undefined}
        className="tlsr-focus flex min-h-11 cursor-pointer list-none items-center justify-between border-b border-[color:var(--tls-border-subtle)] md:mb-2 md:min-h-0 md:cursor-default md:pb-2.5 [&::-webkit-details-marker]:hidden"
      >
        {title}
        <svg
          aria-hidden="true"
          viewBox="0 0 16 16"
          width="16"
          height="16"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          className="shrink-0 text-[var(--tls-fg-muted)] group-open:rotate-180 md:hidden"
        >
          <path d="M3 6l5 5 5-5" />
        </svg>
      </summary>
      {children}
    </details>
  );
}
